module.exports = __webpack_public_path__ + "img/lambda-dark.5bf17852.svg";